export const TdsTypes = [
  { id: 1, label: "Contractor Individual", value: 1 },
  { id: 2, label: "Contractor Company", value: 2 },
  { id: 3, label: "Professional Company", value: 10 },
  { id: 4, label: "Rent", value: 10 },
];